import { styled } from "styled-components";

export const EditTournamentDropBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  border-radius: 14px;
  padding: 12px 16px;
  border: 1px solid #e5e5e5;
  cursor: pointer;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EditTournamentDropBoxItemWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  gap: 4px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  top: 44px;
  right: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`;

export const EditTournamentDropBoxItem = styled.div<{ selected: boolean }>`
  height: 28px;
  padding: 8px 12px;
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10.79px;
  line-height: 28px;
  color: ${(p) => (p.selected ? "#121212" : "#B7B7B7")};
  background: ${(p) => (p.selected ? "#F0F0F0" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
